import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Dashboard from "./publisher/Dashboard";
import Login from "./publisher/Login";
import Register from "./publisher/Register";
import Offers from "./publisher/Offers";
import ApprovedOffers from "./publisher/ApprovedOffers";
import PerformanceReport from "./publisher/PerformanceReport";
import ClickReport from "./publisher/ClickReport";
import ConversionReport from "./publisher/ConversionReport";
import OfferDetails from "./publisher/OfferDetails";
import Profile from "./publisher/Profile";
import Postback from "./publisher/Postback";
import PostbackTest from "./publisher/TestPostback";
import AdminLogin from "./Admin/AdminLogin";
import AdminDashboard from "./Admin/AdminDashboard";
import ManageOffers from "./Admin/ManageOffers";
import OfferApproval from "./Admin/OfferApproval";
import OfferWiseReport from "./Admin/OfferWiseReport";
import PublisherWiseReport from "./Admin/PublisherWiseReport";
import AdminPerformanceReport from "./Admin/PerformanceReport";
import ManagePublishers from "./Admin/ManagePublishers";
import AdvancePublisher from "./Admin/AdvancePublisher";
import PendingBilling from "./Admin/PendingBilling";
import Billing from "./publisher/Billing";
import Settings from "./Admin/Settings";
import ImportLeads from "./Admin/ImportLeads";
import CreateCampaign from "./publisher/CreateCampaign";
import MyCampaigns from "./publisher/MyCampaigns";
import AddDomain from "./publisher/AddDomain";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/offers" element={<Offers />} />
        <Route path="/offers/:offerId" element={<OfferDetails />} />
        <Route path="/offers/approved" element={<ApprovedOffers />} />
        <Route path="/reports/performance" element={<PerformanceReport />} />
        <Route path="/reports/clicks" element={<ClickReport />} />
        <Route path="/reports/conversions" element={<ConversionReport />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/billing" element={<Billing />} />
        <Route path="/postback/global" element={<Postback />} />
        <Route path="/postback/test" element={<PostbackTest />} />
        <Route path="/campaign/add" element={<CreateCampaign />} />
        <Route path="/campaign/list" element={<MyCampaigns />} />
        <Route path="/campaign/domain" element={<AddDomain />} />
        <Route path="/cbMediaAdmin7/" element={<AdminDashboard />} />
        <Route path="/cbMediaAdmin7/login" element={<AdminLogin />} />
        <Route path="/cbMediaAdmin7/offers" element={<ManageOffers />} />
        <Route path="/cbMediaAdmin7/offers/request" element={<OfferApproval />} />
        <Route path="/cbMediaAdmin7/reports/offer" element={<OfferWiseReport />} />
        <Route path="/cbMediaAdmin7/reports/publisher" element={<PublisherWiseReport />} />
        <Route path="/cbMediaAdmin7/reports/performance" element={<AdminPerformanceReport />} />
        <Route path="/cbMediaAdmin7/reports/performance/:id" element={<AdminPerformanceReport />} />
        <Route path="/cbMediaAdmin7/reports/performance/:id/:dateRange" element={<AdminPerformanceReport />} />
        <Route path="/cbMediaAdmin7/publishers/manage" element={<ManagePublishers />} />
        <Route path="/cbMediaAdmin7/publishers/advance" element={<AdvancePublisher />} />
        <Route path="/cbMediaAdmin7/publishers/billing" element={<PendingBilling />} />
        <Route path="/cbMediaAdmin7/settings" element={<Settings />} />
        <Route path="/cbMediaAdmin7/import" element={<ImportLeads />} />

      </Routes>
    </Router>
  );
}

export default App;
